import { DistinctValues } from '../services/invoiceSummary';

interface DistinctTextProps {
    values: DistinctValues;
    singular: string;
    plural: string;
}

export const distinctText = ({ values, singular, plural }: DistinctTextProps): string => {
    if (values.single) return values.single;
    return `${values.count} ${values.count === 1 ? singular : plural}`;
};

export const DistinctText: React.FC<DistinctTextProps> = props => (
    <span className="font-semibold text-gray-900 dark:text-gray-100 truncate" title={distinctText(props)}>
        {distinctText(props)}
    </span>
);

export const CountList: React.FC<{ counts: Record<string, number> }> = ({ counts }) => (
    <span className="inline-flex flex-wrap gap-1">
        {Object.entries(counts).map(([label, count]) => (
            <span key={label}
                className="px-1.5 py-0.5 rounded bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-200 whitespace-nowrap">
                {label} <strong>{count}</strong>
            </span>
        ))}
    </span>
);
